import { render, staticRenderFns } from "./GallupInfos.vue?vue&type=template&id=3713595e&scoped=true"
import script from "./GallupInfos.vue?vue&type=script&lang=js"
export * from "./GallupInfos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3713595e",
  null
  
)

export default component.exports